import React, { useEffect, useState } from "react";
import { TagsFill, StarFill, FolderFill, Diagram3Fill, BarChartLineFill } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";

import Layout from 'components/Layout/Layout';

import Charts from "./help/Charts";
import Favorites from "./help/Favorites";
import Groups from "./help/Groups";
import Tags from "./help/Tags";
import Values from "./help/Values";

import "./styles.css";

const Collections = () => {
	const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
	const [showContent, setShowContent] = useState(false);

	const settingsSections = [
		{ 
			id: "favorites", 
			name: "Favorites", 
			icon: <StarFill size={20} />, 
			subtitle: "Create favorite notches to quick access" 
		},
		{ 
			id: "tags", 
			name: "Tags", 
			icon: <TagsFill size={20} />, 
			subtitle: "Create tags to organize your notches" 
		},
		{ 
			id: "groups", 
			name: "Groups", 
			icon: <FolderFill size={20} />, 
			subtitle: "Create groups to organize your notches" 
		},
		{ 
			id: "values", 
			name: "Values", 
			icon: <Diagram3Fill size={20} />, 
			subtitle: "Create groups to organize your notches" 
		},
		{ 
			id: "charts", 
			name: "Charts", 
			icon: <BarChartLineFill size={20} />, 
			subtitle: "Create favorite notches to quick access" 
		},
    ];
	const [activeSection, setActiveSection] = useState(isMobile ? null : "favorites");

	const navigate = useNavigate();

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 768);
			if (window.innerWidth >= 768) setShowContent(false);
		};


		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

    const renderContent = () => {
        switch (activeSection) {
            case "tags":
                return <Tags 
					setShowContent={setShowContent}
				/>;
            case "favorites":
                return <Favorites 
					setShowContent={setShowContent}
				/>;
			case "groups":
                return <Groups 
					setShowContent={setShowContent}
				/>;
			case "values":
                return <Values 
					setShowContent={setShowContent}
				/>;
			case "charts":
                return <Charts 
					setShowContent={setShowContent}
				/>;
            default:
                return null;
        }
    };

    return (
        <Layout title="Collections">
			<div className="row">

				{!isMobile || !showContent ? (
					<div className="col-md-4">

						<div className="card container-height left-navigation">
							<div className="card-body px-0">
								<ul className="list-unstyled flex-grow-1">
									{settingsSections.map((section) => (
										<li
											key={section.id}
											className={`d-flex align-items-center p-2 rounded cursor-pointer ${activeSection === section.id ? "bg-primary text-white" : "themed-text"}`}
											onClick={() => {
												setActiveSection(section.id);
												setShowContent(true);
											}}
											style={{ cursor: "pointer" }}
										>
											<span className="me-2">{section.icon}</span> {section.name}
										</li>
									))}
								</ul>
							</div>

						</div>

					</div>
				) : null}

				 <div className="col-md-8">
					{(!isMobile || showContent) && renderContent()}
				 </div>
			</div>
		</Layout>
    );
};

export default Collections;
